import { useCallback } from 'react';
import { useAxiosInstance } from '@gov-nx/api/axios';
import {
	ignoreErrors,
	isResponseStatus,
	useUnauthorizedResponse,
} from '@gov-nx/api/errors/utils';
import { usePoMutation } from '@gov-nx/api/hooks/usePoMutation';
import { authLogoutQuery } from '@gov-nx/api/queries/authQuery';
import { useUserLoginInfo } from '@gov-nx/core/hooks/User/userLoginInfo';
import { useConfiguration } from '@gov-nx/core/service/configuration/useConfiguration';
import { useAppLogout } from '@gov-nx/store/hooks/useAppLogout';
import { isNiaLoginType } from '@gov-nx/utils/common/Auth/auth';
import { useSessionStorage } from '@gov-nx/utils/web/hooks/useSessionStorage';
import { pageRouteResolver } from '../Router/routeResolver';

export const useUserLogout = () => {
	const { poServerUrl } = useConfiguration();
	const { loginType } = useUserLoginInfo();
	const { logout } = useAppLogout();
	const { axiosInstance } = useAxiosInstance();
	const { isUnauthorizedResponse } = useUnauthorizedResponse();
	const logoutInProgress = useSessionStorage('logoutInProgress');

	const niaLogoutMutation = usePoMutation(
		{
			mutationKey: ['nia-logout'],
			mutationFn: () => authLogoutQuery(axiosInstance),
			retry: false,
			onSettled: (niaResponse) => {
				if (niaResponse?.url) {
					logout();
					window.location.href = poServerUrl + niaResponse.url;
				} else {
					logout();
					window.location.href = pageRouteResolver('odhlaseni');
				}
			},
		},
		{
			errorIgnoreFilter: ignoreErrors(
				isUnauthorizedResponse,
				isResponseStatus(400)
			),
		}
	);

	const onUserLogout = useCallback(async () => {
		logoutInProgress.set('true');

		if (isNiaLoginType(loginType)) {
			return niaLogoutMutation.mutate();
		}
		logout();
		window.location.href = pageRouteResolver('odhlaseni');
	}, [loginType, logout, niaLogoutMutation, logoutInProgress]);

	return { onUserLogout };
};
